import { cva } from '@/styled-system/css';

export const buttonIconRecipe = cva({
  base: {
    transition: {
      _motionReduce: 'none',
      _motionSafe: '200ms ease color',
    },
  },
  variants: {
    tone: {
      brand: {},
      neutral: {},
      critical: {},
    },
    emphasis: {
      filled: {},
      outlined: {},
    },
    disabled: {
      true: {},
      false: {},
    },
    onImpact: {
      true: {},
      false: {},
    },
    loading: {
      true: {
        color: 'transparent.invisible',
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      emphasis: 'filled',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'Button.filled.brand.label.default',
        },
      },
    },
    {
      emphasis: 'filled',
      tone: 'critical',
      loading: false,
      css: {
        color: {
          base: 'Button.filled.critical.label.default',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'Button.outlined.brand.label.default',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'neutral',
      loading: false,
      css: {
        color: {
          base: 'Button.outlined.neutral.label.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'filled',
      tone: 'brand',
      loading: false,
      css: {
        color: {
          base: 'Button.onImpact.filled.brand.label.default',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'neutral',
      loading: false,
      css: {
        color: {
          base: 'Button.onImpact.outlined.neutral.label.default',
        },
      },
    },
    // broken out due to some specificity issues
    {
      emphasis: 'filled',
      tone: 'brand',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Button.filled.brand.label.hover',
          _groupActive: 'Button.filled.brand.label.pressed',
        },
      },
    },
    {
      emphasis: 'filled',
      tone: 'critical',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Button.filled.critical.label.hover',
          _groupActive: 'Button.filled.critical.label.pressed',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'brand',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Button.outlined.brand.label.hover',
          _groupActive: 'Button.outlined.brand.label.pressed',
        },
      },
    },
    {
      emphasis: 'outlined',
      tone: 'neutral',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Button.outlined.neutral.label.hover',
          _groupActive: 'Button.outlined.neutral.label.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'filled',
      tone: 'brand',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Button.onImpact.filled.brand.label.hover',
          _groupActive: 'Button.onImpact.filled.brand.label.pressed',
        },
      },
    },
    {
      onImpact: true,
      emphasis: 'outlined',
      tone: 'neutral',
      loading: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Button.onImpact.outlined.neutral.label.hover',
          _groupActive: 'Button.onImpact.outlined.neutral.label.pressed',
        },
      },
    },
  ],
});
